export const CONTRACT_TYPES = {
  CONTRACT: "contract",
  ENDORSEMENT: "endorsement",
  RENEWAL: "renewal",
};
